module.exports = __webpack_public_path__ + "img/80015.db13f86a.png";